<template>
    <div class="layout-container">
        <!-- <video muted  autoplay="true" loop style="width:100%; height:100%; object-fit: fill">
            <source src="../../assets/img/lgbg.mp4" type="video/mp4">
        </video> -->
        <div class="bg">
         <div class="layout-header">
            <span class="name">{{ text }}</span>
        </div>
        <div class="layout-description">
            {{ desc }}
        </div>
        <div class="layout-content" style="margin-top:150px;">
            <transition
                name="fade-transform"
                mode="out-in"
            >
                <router-view/>
            </transition>
            <div style="width: 100%;text-align: center;color: #aaa;position: absolute;bottom: 10px;left: -5px">
                Copyright <svg-icon icon-class="copyright" /> {{copyright}}
            </div>
        </div>
        <div class="layout-footer" v-show="false">
      <span
          style="margin-right:2px;"
          class="footer-copyright"
      >
        Copyright © 2021 - 2022 xxxx有限公司
      </span>
            <span class="f">|</span>
            <span class="footer-links">
        <el-link
            class="footer-link"
            size="mini"
            :underline="false"
        >帮助</el-link>|<el-link
                class="footer-link"
                size="mini"
                :underline="false"
            > 隐私 </el-link>|<el-link
                class="footer-link"
                size="mini"
                :underline="false"
            >条款</el-link>
            </span>
        </div>
        </div>
    </div>
</template>

<script>
import defaultSettings from '@/settings'

export default {
    name: 'AuthIndex',
    data() {
        return {
            logo: defaultSettings.loginLogo,
            text: defaultSettings.loginText,
            desc: defaultSettings.loginDesc,
            copyright:defaultSettings.copyright
        }
    },
    created() {

    },
    methods: {}
}
</script>

<style scoped lang="scss">
.layout-container {
    padding: 0;
    margin: 0;
     background-image: url('../../assets/img/bg.png');
    background-color: #f0f2f5;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100vw;
    height: 100vh;
   

    .bg{
        width: 500px;
        height: 550px;
        background:rgba(255,255,255,1);
        opacity:.9;
        position: absolute;
        border-radius: 15px;
        top: 30vh;
        left: calc(50vw - 225px);
        @media (min-width: 768px) {
            top: calc(100vh - 650px);
        }
        @media (max-width: 767px) {
            margin-top: 50px;
        }
    }

    .layout-header {
        display: flex;
        justify-content: center;
        margin: 80px auto;
        width: 100%;
        height: 50px;

        .name {
            font-size: 20px;
            margin-left: 0px;
        }

        position: absolute;
    }

    .layout-description {
        margin: 120px auto;
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #aaa;
        position: absolute;
       
    }

   
    

       

      
    
}

</style>
